function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoTrailsOfIceAndFireSimpleColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 103 107",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1287.82,-172.304)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.87635,2088.16,-106.264)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.60607,0,0,1.3889,-2196.36,-153.19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M535.681,219.803L537.115,217.187L553.816,226.237L553.816,217.189L556.816,217.189L556.816,226.173L573.397,217.188L574.833,219.826L571.833,221.45L571.833,221.448L568.634,223.181L558.399,228.721L558.405,228.724L558.405,228.724L571.833,236.001L571.833,236.001L574.833,237.627L558.399,246.521L558.409,246.527L558.405,246.529L571.833,253.805L571.833,253.801L574.833,255.427L573.4,258.066L556.816,249.08L556.816,258.156L553.816,258.156L553.816,249.016L537.101,258.074L535.681,255.434L552.111,246.53L535.709,237.635L552.105,228.727L552.108,228.724L549.153,227.123L535.681,219.803ZM541.977,237.627L553.816,244.042L553.816,231.211L541.977,237.627ZM556.816,231.275L556.816,243.978L568.536,237.627L556.816,231.275Z",
    style: {
      fill: "url(#_Linear1)"
    }
  })))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.11667e-13,40.9672,-40.9672,1.11667e-13,555.257,217.189)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(96,194,211)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(212,43,69)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTrailsOfIceAndFireSimpleColor);
export default __webpack_public_path__ + "static/media/logo-trails-of-ice-and-fire-simple-color.43ca6b327992a9a5a58c5ba855b55ed5.svg";
export { ForwardRef as ReactComponent };